{{
  'project.steps.providerResults.individual.completeness'
    | transloco: {answered: completeness().answered, total: completeness().total}
}}
